/* Three behaviours for the install options. This <script> is only emitted when
   it is actually needed (see the end of the snippet).

   1. The image swatch heading follows the selected value
      "Ceiling Type: Flat Ceiling" — matching the Color row on the product page.
      Dawn's own version is driven by the variant-selects JS and only reacts to
      variant changes; this is a line item property, not a variant, so it has to
      update itself.

   2. An empty downrod length means the property is not submitted
      Leaving it blank means "the standard length for this fixture's size". If
      an empty value were submitted anyway, the order would carry a blank
      "Downrod Length" line and the factory would read it as something the
      customer forgot to fill in. Dawn's cart does filter empty properties
      (property.last != blank in main-cart-items.liquid), but that only hides
      them from display; the order still carries them. So the empty input's name
      attribute is removed just before submit and restored immediately after.

   3. Clamp to min/max
      The product form is novalidate (Dawn adds that itself in
      buy-buttons.liquid), so the browser does not enforce min/max and the
      attributes alone do nothing. This clamps once on change (which fires on
      blur/Enter, not on every keystroke), so a customer typing 500 cannot
      actually place that order. */

if (!customElements.get('ah-install-options')) {
  customElements.define(
    'ah-install-options',
    class AhInstallOptions extends HTMLElement {
      connectedCallback() {
        this.selectedOutput = this.querySelector('[data-inst-selected]');
        this.optionalInputs = this.querySelectorAll('[data-optional-property]');

        if (this.selectedOutput) {
          this.addEventListener('change', (event) => {
            if (event.target.type !== 'radio') return;
            this.selectedOutput.textContent = event.target.value;
          });
        }

        if (!this.optionalInputs.length) return;

        this.optionalInputs.forEach((input) => {
          input.addEventListener('change', () => this.clamp(input));
        });

        /* The listener is on document and uses the capture phase: Dawn's
           product-form.js binds its submit listener to the <form> itself, and
           the order of capture vs. bubble listeners on the SAME element depends
           on registration order (unreliable), whereas a capture listener on an
           ancestor always runs before any listener on the target. That is the
           only way to guarantee the edit lands before new FormData(form). */
        document.addEventListener('submit', this.onSubmit.bind(this), true);
      }

      onSubmit(event) {
        if (event.target.id !== this.dataset.formId) return;

        this.optionalInputs.forEach((input) => {
          if (input.value.trim() !== '') return;
          const name = input.name;
          input.name = '';
          // Fool only this one FormData, then restore; otherwise a second submit could never go through.
          setTimeout(() => {
            input.name = name;
          }, 0);
        });
      }

      clamp(input) {
        if (input.value.trim() === '') return;
        const value = parseFloat(input.value);
        if (Number.isNaN(value)) return;

        const min = parseFloat(input.min);
        const max = parseFloat(input.max);
        if (!Number.isNaN(min) && value < min) input.value = min;
        if (!Number.isNaN(max) && value > max) input.value = max;
      }
    }
  );
}
